import React from "react";
 
import arrowIcon from '../../../assets/img/arrow.svg'
import { useHistory } from 'react-router-dom';


const SettingsMobileItem = ({ name, link }) => {
  const history = useHistory();
 
  return (
    <div className={"settingsMobileItemContainer"} onClick={() => history.push(link)}>
      <span className={"itemName BODY_MEDIUM"}>
        { name }
      </span>
      <img src={arrowIcon} alt={name}/>
    </div>
  );
}

export default SettingsMobileItem;
